@if (bootingUp()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
}
@if (!bootingUp()) {
	<app-form-box>
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<app-form-label>Create Account</app-form-label>
			<br />
			<app-text-field
				[fg]="form"
				formGroupOrControlName="firstName"
				label="First Name"
				placeholder="First Name"
			></app-text-field>
			<br />
			<app-text-field
				[fg]="form"
				formGroupOrControlName="lastName"
				label="Last Name"
				placeholder="Last Name"
			></app-text-field>
			<br />
			<app-text-field
				[fg]="form"
				formGroupOrControlName="username"
				label="E-Mail or Student ID"
				placeholder="E-Mail or Student ID"
				autocomplete="username"
			></app-text-field>
			<br />
			<app-textarea-field
				[fg]="form"
				formGroupOrControlName="sectionCodes"
				label="Section / Class Codes (one per line, E.G. AB12CD34)"
				placeholder="Section / Class Codes (one per line)"
			></app-textarea-field>
			@if (!isEduskillsAllowed()) {
				<br />
			}
			<app-form-submit-button [disabled]="!form.valid || loading" [loading]="loading">
				Create Account
			</app-form-submit-button>
		</form>
		<br />
		<div class="footer-links">
			<app-form-link (click)="onBack()">Back</app-form-link>
		</div>
	</app-form-box>
}
